var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGloves2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.253,
    height: 54.243,
    viewBox: "0 0 54.253 54.243",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gloves",
    transform: "translate(0.255 0.221)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73513",
    "data-name": "Group 73513",
    transform: "translate(27.231 7.022)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73512",
    "data-name": "Group 73512"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89095",
    "data-name": "Path 89095",
    d: "M287.073,40.02a1.05,1.05,0,1,0,1.05,1.05A1.05,1.05,0,0,0,287.073,40.02Z",
    transform: "translate(-286.023 -40.02)",
    fill: "#a6a6a6",
    stroke: "#a6a6a6",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_73515",
    "data-name": "Group 73515",
    transform: "translate(-0.001 0.03)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73514",
    "data-name": "Group 73514",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89096",
    "data-name": "Path 89096",
    d: "M50.6,40.546H46.82V15.774A15.734,15.734,0,0,0,30.591.037C22.009.295,15.33,7.733,15.33,16.39v5.385l-2.812-2.8A7.352,7.352,0,0,0,1.2,20.093,7.478,7.478,0,0,0,2.3,29.533L13.286,40.494l1.736,1.73a1.441,1.441,0,0,1,.309.744v7.655a3.153,3.153,0,0,0,3.149,3.149H43.671a3.153,3.153,0,0,0,3.149-3.149V46.844H50.6a3.149,3.149,0,1,0,0-6.3ZM44.721,50.623a1.051,1.051,0,0,1-1.05,1.05H18.479a1.051,1.051,0,0,1-1.05-1.05V46.844H44.721Zm0-5.878H17.43V42.968a3.456,3.456,0,0,0-.926-2.231l-1.736-1.729L3.782,28.048a5.377,5.377,0,0,1-.84-6.778,5.249,5.249,0,0,1,8.093-.812l7.515,7.49a1.05,1.05,0,1,0,1.482-1.487l-2.6-2.593V16.39c0-7.641,5.933-14.036,13.225-14.255A13.636,13.636,0,0,1,44.721,15.774C44.721,16.919,44.721,43.384,44.721,44.745Zm5.878,0H46.82v-2.1H50.6a1.05,1.05,0,1,1,0,2.1Z",
    transform: "translate(0.001 -0.03)",
    fill: "#a6a6a6",
    stroke: "#a6a6a6",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_73517",
    "data-name": "Group 73517",
    transform: "translate(31.346 7.861)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73516",
    "data-name": "Group 73516"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89097",
    "data-name": "Path 89097",
    d: "M326.679,48.1a1.05,1.05,0,1,0-.825,1.93,9.445,9.445,0,0,1,5.745,8.692v4.828a1.05,1.05,0,1,0,2.1,0V58.723A11.542,11.542,0,0,0,326.679,48.1Z",
    transform: "translate(-325.217 -48.016)",
    fill: "#a6a6a6",
    stroke: "#a6a6a6",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_73519",
    "data-name": "Group 73519",
    transform: "translate(30.736 33.553)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73518",
    "data-name": "Group 73518"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89098",
    "data-name": "Path 89098",
    d: "M317.07,345.987a1.05,1.05,0,0,0-1.05,1.05v4.2a1.05,1.05,0,1,0,2.1,0v-4.2A1.05,1.05,0,0,0,317.07,345.987Z",
    transform: "translate(-316.02 -345.987)",
    fill: "#a6a6a6",
    stroke: "#a6a6a6",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_73521",
    "data-name": "Group 73521",
    transform: "translate(36.325 33.553)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73520",
    "data-name": "Group 73520"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89099",
    "data-name": "Path 89099",
    d: "M377.064,345.987a1.05,1.05,0,0,0-1.05,1.05v4.2a1.05,1.05,0,0,0,2.1,0v-4.2A1.05,1.05,0,0,0,377.064,345.987Z",
    transform: "translate(-376.014 -345.987)",
    fill: "#a6a6a6",
    stroke: "#a6a6a6",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_73525",
    "data-name": "Group 73525",
    transform: "translate(25.148 33.553)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73524",
    "data-name": "Group 73524"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89101",
    "data-name": "Path 89101",
    d: "M197.083,345.987a1.05,1.05,0,0,0-1.05,1.05v4.2a1.05,1.05,0,1,0,2.1,0v-4.2A1.05,1.05,0,0,0,197.083,345.987Z",
    transform: "translate(-196.033 -345.987)",
    fill: "#a6a6a6",
    stroke: "#a6a6a6",
    strokeWidth: 0.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGloves2);
export default __webpack_public_path__ + "static/media/gloves (2).31b80e2111b67584e98a75c7772ba15d.svg";
export { ForwardRef as ReactComponent };